import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2000393e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_2 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_4 = { class: "mt-10 mb-10" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("在线制单")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("内部转账")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("流转至工资发放")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("导出")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("颜色含义")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("表格颜色")
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "colorMean gray-row" }, "驳回，支付失败", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "colorMean lightBule-row" }, "支付成功", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "colorMean green-row" }, "等待支付", -1))
const _hoisted_14 = { class: "el-dropdown-link" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" 操作 ")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("银行备注")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("加急处理")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("取消加急")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("重新支付")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("驳回")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("绑定流水")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_23 = /*#__PURE__*/_createTextVNode("确认转账")
const _hoisted_24 = /*#__PURE__*/_createTextVNode("保存")
const _hoisted_25 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_26 = /*#__PURE__*/_createTextVNode("保存")
const _hoisted_27 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_28 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_29 = /*#__PURE__*/_createTextVNode("新增")
const _hoisted_30 = /*#__PURE__*/_createTextVNode("选择")
const _hoisted_31 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_32 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_33 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_34 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_35 = /*#__PURE__*/_createTextVNode("绑定")


const __default__ = {
  name: "PaymentPool"
}
import { ref, reactive, computed, onActivated, onBeforeMount } from 'vue'
import { useStore } from "vuex"
import { businessCodeType } from '@/views/typeMapping/PaymentModuleUtils'
import { paymentTypeOption } from '@/views/typeMapping/Financial';
import { useRouter } from "vue-router"
// import ExpenseSearchForm from "@/components/ExpenseSearchForm.vue"
import tbMix from '@/global_mixin/tableMixin'
import { ElMessage, ElMessageBox } from 'element-plus'
import { formatNumber, getNumber } from '@/utils/index'
import type { FormInstance, FormRules } from 'element-plus'
import Api from '@/http/modules/index'
import PaymentModuleUtils from "@/views/typeMapping/PaymentModuleUtils"
import dayjs from 'dayjs'
type SearchForm = {
  no: number | null
  id: string
  typeList: string[]
  status: string[] | null
  payApproveStatusList: string[]
  estimateAmountStart: number | undefined
  estimateAmountEnd: number | undefined
  [propName: string]: any
}
// 搜索

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const { statusFilter, filterType, accountNoFilter, accountNO } = PaymentModuleUtils
const ruleFormRef = ref<FormInstance>()
const searchFormEle = ref<FormInstance>()
const {
  //下拉框选项
  'GET/pay_pool/drop_list': drapListApi,
  //条件查询
  'POST/pay_pool/conditions': reimburseConditionsApi,
  //状态紧急处理
  'PATCH/pay_pool/urgent': reimburseApi,
  //检测勾选数据是否满足支付要求
  'POST/pay_pool/prepare_pay': preparePayApi,
  //更新备注
  'PATCH/pay_pool/update_note': updateNoteApi,
  // 
  'GET/pay_pool/conditions_drop_box': conditionsDropBoxApi,
  // 内部转账
  'POST/pay_pool/internal_pay': payPoolInternalPayApi,
  // 重新支付
  'PATCH/pay_pool/repayments': repaymentsApi,
  // 导出
  'POST/invoice/download': invoiceDownloadApi,
  // 房租水电文件下载
  'GET/house_lease_contracts/download': detailDownloadApi,
  // 驳回
  'POST/approved/reject': approvedRejectApi,
  // 新增薪酬导入表
  'POST/salaries/salary_imports':salaryImportsApi,
  // 转薪酬查询
  'POST/pay_pool/transfer_payroll/query':transferPayrollQueryApi,
  // 转薪酬
  'POST/pay_pool/transfer_payroll':transferPayrollApi,
  // 薪酬项目维护(按种类划分)
  'GET/salary_categories': salary_categoriesApi,
  // 获取银行流水
  'POST/financial_flows/conditions': conditionsApi,
  // 支付池 绑定交易记录
  'POST/pay_pool/bind': bindApi,
  // 支付池_交易记录明细查询
  'POST/pay_pool/flow_detail': flow_detailApi,
  // 支付池_解绑交易记录(删除)
  'POST/pay_pool/unbind': unbindApi,
} = Api;

const currentPage = ref<number>(1)
const pageSize = ref<number>(30)
const tableRowCount = ref<number>(0)
const searchForm: SearchForm = reactive({
  no: null,
  id: '',
  payeeCompanies: [],
  department: "",
  accountNo: "",
  typeList: ["COST_REIMBURSE"],
  category: "",
  matter: "",
  status: ['PAY_WAIT', 'PAY_NO'],
  createTime: [],
  payApproveStatusList: ['APPROVE_SUCCESS', 'APPROVE_SEC', 'APPROVE_WAIT'],
  approvedBy: "",
  cashier: "",
  approvedRecordId: "",
  creator: "",
  estimateAmountStart: undefined,
  estimateAmountEnd: undefined,
})
const cascaderProps = {
  checkStrictly: true,
  label: 'name',
  value: 'id'
}
const categoryList = reactive([
  {
    category: '长期经营资产购置',
    matter: ["经营办公物业购置", "经营办公设施、设备及器具购置", "信息系统购置", "装修/修缮工程"]
  },
  {
    category: '对外投资项目',
    matter: ["投资理财", "对外投资设立（分）子公司", "企业并购"]
  },
  {
    category: '采购商品/接受劳务',
    matter: ["经营用水电气/物管/租金", "译员劳务购买", "软件/技术服务", "其他"]
  },
  {
    category: "日常业务经费",
    matter: ["公务接待费", "车辆运行及市内交通费", "差旅费", "培训费/会议费", "其他", "办公用品费", "招聘费"]
  },
  {
    category: "备用金借支",
    matter: ["个人借款", "公务借款"]
  },
  {
    category: "市场推广专项经费",
    matter: ["专项业务活动费", "广告宣传费（含设计费/宣传品）", "其他", "软件/技术服务"]
  },
  {
    category: "职工薪酬",
    matter: ["员工福利", "绩效奖励", "团建费", "业务提成", "工资、五险一金"]
  },
  {
    category: "知识产权费",
    matter: ["商标费", "著作权费", "专利费", "资质费", "其他IP费"]
  },
  {
    category: "销售退款",
    matter: ["境内客户", "境外客户"]
  },
  {
    category: "税款-tax fee",
    matter: ["税款"]
  },
  {
    category: "偿还贷款",
    matter: ["短期借款偿还", "长期借款偿还"]
  },
  {
    category: "校企合作费用",
    matter: ["差旅费", "校企接待费", "活动经费"]
  },
])
const metterList: any = ref([])
const categoryChange = (data: string) => {
  searchForm.matter = ''
  metterList.value = categoryList.find(el => el.category === data)?.matter ?? []
}

const searchQuery = (isQuery = false) => {
  if (isQuery) {
    currentPage.value = 1
  }
  if (!searchForm.status) {
    searchForm.status = null
  }
  tableLoading.value = true
  reimburseConditionsApi({
    query: {
      ...searchForm,
      createTime: {from: searchForm.createTime?.[0], to: searchForm.createTime?.[1]}
    },
    page: currentPage.value,
    size: pageSize.value
  }).then((res: any) => {
    tableData.value = res.data
    tableRowCount.value = res.rowCount
  }).finally((res: any) => {
    tableLoading.value = false
  })
}
const pageChange = (page: number) => {
  currentPage.value = page
  searchQuery()
}
const sizeChange = (size: number) => {
  pageSize.value = size
  currentPage.value = 1
  searchQuery()
}

// 获取初始化数据
let dropListArr: any = ref({})
let paymentDropList: any = ref([])
const transferDropList = ref<{company: string}[]>([])
onBeforeMount(() => {
  searchQuery()
  drapListApi().then((res: any) => {
    res.companyCascader = res.payeeCompanies
    dropListArr.value = res
  }).catch(() => { })
  // 获取付款公司
  conditionsDropBoxApi({currency: 'CNY'}).then((res: any) => {
    transferDropList.value = res
  })
  getSalaryPackage()
  salary_categoriesApi({type:'ALL'}).then((res:any)=>{
    salaryCategoryList.value=res
  })
  // 获取流水绑定款项类型
  paymentTypeOption().then((option: any) => {
    paymentDropList.value = option
  })
})

// --------------------

let store = useStore()
const payTableEle = ref()
let router = useRouter()

const tableData = ref([])

const mySearch = ref()
const tableLoading = ref(true)
const selectionData = ref<any[]>([])
//详情数据
const dialogFeeVisible = ref(false)
const payerBankList = ref([])
const payerAcountNameList = ref<{accountId: string, accountName: string}[]>([])
const payeeAcountNameList = ref([])
const payeeBankList = ref([])
const transferLoading = ref(false)
const approvalDialogVisiable = ref(false)
const repaymentsVisible = ref(false)
const repaymentsModel = ref({
  payeeAccountName: "",
  payeeBankName: "",
  payeeAcc: "",
  id: ""
})
const transferData: any = ref({
  "businessCode": "",
  "payerCompany": "",
  "payerBankName": "",
  "payerId": store.state.userId,
  "payerAcc": "",
  "payType": "1",
  "estimateAmount": undefined,
  "amount": undefined,
  "payeeCompany": "",
  "payeeAccountName": "",
  "payeeBankName": "",
  "payeeAcc": "",
  "payeeCurrency": "CNY",
  "note": ""
})
// accountNoFilter()
const transferRules = reactive<FormRules>({
  "businessCode": [{ required: true, message: '请选择费用类型', trigger: 'change' }],
  "payerCompany": [{ required: true, message: '请选择付款公司', trigger: 'change' }],
  "payerBankName": [{ required: true, message: '请选择付款银行', trigger: 'change' }],
  "payerAcc": [{ required: true, message: '请选择付款账号', trigger: 'change' }],
  "payType": [{ required: true, message: '请选择付款方式', trigger: 'change' }],
  "estimateAmount": [{ required: true, message: '请输入申请金额', trigger: 'change' }],
  "amount": [{ required: true, message: '请输入支付金额', trigger: 'change' }],
  "payeeCompany": [{ required: true, message: '请选择收款公司', trigger: 'change' }],
  // "payeeAccountName": [{ required: true, message: '请选择收款账户名', trigger: 'change' }],
  "payeeBankName": [{ required: true, message: '请选择收款银行', trigger: 'change' }],
  // "payeeAcc": [{ required: true, message: '请选择收款账号', trigger: 'change' }],
  "payeeCurrency": [{ required: true, message: '请选择币种', trigger: 'change' }],
})
// 业务类型下拉
let businessOption = computed(() => {
  return businessCodeType()
})

onActivated(() => {
  payTableEle.value?.clearSelection()
  searchQuery()
})


const urgentHandle = (data: any, row: any) => {
  ElMessageBox.confirm(`确定${row.urgent === 0 ? '为' : '取消'}此数据 (ID:${row.id}) 加急处理?`, '提示',).then(() => {
    let params = new FormData()
    params.append('urgent', data)
    params.append('id', row.id)
    return reimburseApi(params)
  }).then(() => {
    row.urgent = data
    ElMessage.success(data === 1 ? '以为该数据进行加急处理' : "已取消该数据的加急处理")
  })
}
const checkboxSelect = (row: any, rowIndex: number) => {
  if (row.status === 'PAYMENT_REISSUED') return false;
  if (row.status == 'PAY_NO' && row.approvedStatus != 'TRUN_DOWN') return true;
  return false
}
const handleSelectionChange = (rows: any) => {
  selectionData.value = rows
}
const getRowKey = (row: any) => {
  return row.id
}
const swtichPaymentPage = () => {
  // 判断币种是否相同
  const allSame = selectionData.value.every((item: any) => item.payeeCurrency === selectionData.value[0].payeeCurrency);
  if (!allSame) {
    ElMessage.warning('币种不一致')
    return
  }

  let ids = selectionData.value.map((e: any) => e.id)
  preparePayApi({ ids }).then((res: any) => {
    store.commit("SET_PAY_DATA", selectionData.value)
    store.commit("SET_PAYMENT_DATA", res)
    router.push({ name: "Pay", /* params: {ids}, */ })
  }).catch(() => {

  })
}



const payerCompanyChange = (value: any) => {
  let target: any = transferDropList.value.find((el: any) => el.company == value)
  payerBankList.value = target.bankList
  transferData.value.payerBankName = ""
  transferData.value.payerAcc = ""
}
const payerBankNameChange = (value: any) => {
  let res: any = payerBankList.value.find((el: any) => el.bankName == value)
  payerAcountNameList.value = res.accountList
  transferData.value.payerAcc = ""
}
const payeeCompanyChange = (value: any) => {
  let target: any = transferDropList.value.find((el: any) => el.company == value)
  payeeBankList.value = target.bankList
  transferData.value.payeeBankName = ""
  transferData.value.payeeAcc = ""
  transferData.value.payeeAccountName = ""
}
const payeeBankNameChange = (value: any) => {
  let res: any = payeeBankList.value.find((el: any) => el.bankName == value)
  payeeAcountNameList.value = res.accountList
  transferData.value.payeeAcc = ""
  transferData.value.payeeAccountName = ""
}
const payeeAccountNameChange = (value: any) => {
  let res: any = payeeAcountNameList.value.find((el: any) => el.accountName === value)
  transferData.value.payeeAcc = res.accountId
}
const closeTransferDialog = (formEl: FormInstance | undefined) => {
  if (!formEl) return
  formEl.resetFields()
  transferData.value.note = ""
}
const saveTransferData = async (formEl: FormInstance | undefined) => {
  if (!formEl) return
  await formEl.validate((valid: any, fields: any) => {
    if (valid) {
      transferLoading.value = true
      payPoolInternalPayApi({
        ...transferData.value,
        businessCode: transferData.value['businessCode'].valueStr
      }).then(() => {
        ElMessage.success("创建成功")
        dialogFeeVisible.value = false
        transferLoading.value = false
        searchQuery()
      }).catch((res: any) => {
        transferLoading.value = false

      })
    } else {
    }
  })
}
const oepnRepaymentsVisible = (data: any) => {
  let { id, payeeAccountName, payeeBankName, payeeAcc } = data
  repaymentsModel.value.id = id
  repaymentsModel.value.payeeAccountName = payeeAccountName
  repaymentsModel.value.payeeBankName = payeeBankName
  repaymentsModel.value.payeeAcc = payeeAcc
  repaymentsVisible.value = true
}
const repaymentsMethod = () => {
  repaymentsApi(repaymentsModel.value as any).then(() => {
    ElMessage.success("保存成功")
    searchQuery()
    repaymentsVisible.value = false
  })
}
const exportInvoiceData = () => {

  let params = JSON.parse(JSON.stringify(searchForm))
  let { createTime } = params
  params.createTime = {
    from: createTime ? dayjs(createTime[0]).format("YYYY-MM-DD") : "",
    to: createTime ? dayjs(createTime[1]).format("YYYY-MM-DD") : ""
  }
  invoiceDownloadApi(params, { timeout: 5 * 60000, responseType: 'blob' }).then((res: any) => {
    let fileName = decodeURI(res.headers['content-disposition'].split(';')[1].split('filename=')[1])
    let url = window.URL.createObjectURL(
      new Blob([res.data], { type: 'application/vnd.ms-excel;charset=utf-8' })
    )

    let link = document.createElement("a")
    link.style.display = "none"
    link.href = url
    link.setAttribute(
      "download",
      decodeURI(fileName)
    )
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  })
}

// 高度
const tableHeight = computed(() => window.innerHeight - 210)
// 编辑支付备注功能
const noteVisiable = ref(false)
const editNoteId = ref()
const noteText = ref("")
const editNote = (data: any) => {
  let { id, bankNote } = data
  editNoteId.value = id
  noteText.value = bankNote
  noteVisiable.value = true
}
const setNote = () => {
  let params = {
    id: editNoteId.value,
    note: noteText.value
  }
  updateNoteApi(params).then((res: any) => {
    ElMessage.success("编辑成功")
    noteVisiable.value = false
    let idx = tableData.value.findIndex((el: any) => el.id == editNoteId.value)
    tableData.value[idx].bankNote = noteText.value
  })

}
const downloadFile = (data: any) => {
  if (!data.fileId) return
  let params = { fileId: data.fileId }
  detailDownloadApi(params).then(url => {
    const elt = document.createElement('a')
    elt.setAttribute('href', url)
    elt.setAttribute('download', data.filename)
    elt.style.display = 'none'
    document.body.appendChild(elt)
    elt.click()
    document.body.removeChild(elt)
  })

}

// 驳回
const rejectFg = ref(false)
const rejectReason = ref('')
let rejectData: any
const showReject = (data: any) => {
  rejectData = data
  rejectFg.value = true
}
const rejectApprove = () => {
  if (rejectReason.value === '') {
    ElMessage.warning('请输入驳回原因')
    return
  }
  const formData: any = new FormData()
  formData.append('billId', rejectData.id)
  formData.append('rejectReason', rejectReason.value)
  approvedRejectApi(formData)
    .then(res => {
      ElMessage.success("驳回成功")
      rejectFg.value = false
      selectionData.value=[]
      payTableEle.value?.clearSelection()
      searchQuery()
    })
}


// 展示已绑定流水
const boundDate = ref<any>([])
const boundLoad = ref<boolean>(false)
let boundId: any = ''
const showBoundFlow = (row: {id: number}) => {
  boundLoad.value = true
  boundId = row.id
  flow_detailApi({id: row.id}).then((rep: any) => {
    boundDate.value = rep
  }).finally(() => {
    boundLoad.value = false
  })
}
const delDetails = (flowId: number) => {
  ElMessageBox.confirm('请确认是否删除', '提示').then(() => {
    return unbindApi({flowId})
  }).then(() => {
    showBoundFlow({id: boundId})
    ElMessage.success('解绑成功')
  })
}
const bindTotal = (param: any) => {
  const { columns, data } = param
  let sums: string[] = ['合计']
  sums[3] = boundDate.value.reduce((total: number, row: any) => {    
    return total += (row.costOut - row.costIn)
  }, 0)
  sums[3] = getNumber(sums[3])
  return sums
}
// 绑定流水
const boundEle = ref()
const isShowBound = ref<boolean>(false)
const boundObj = reactive({
  collectionAt: [], createdAt: {}, bankName: '', costFrom: [],
  costInStart: undefined, costInEnd: undefined, summary: '',
  costOutStart: undefined, costOutEnd: undefined, paymentType: ''
})
const {
  MI_tableData, fetchData, page, size, MI_total, 
  MI_pageChange, MI_sizeChange, MI_identify
} = new tbMix(conditionsApi)
const showUnboundFlow = (row: {id: number}) => {
  // 展示流水
  showBoundFlow(row)
  isShowBound.value = true
  boundId = row.id
  searchBound()
}
const searchBound = () => {
  fetchData({
    query: {
      ...boundObj,
      collectionAt: {
        from: boundObj.collectionAt?.[0],
        to: boundObj.collectionAt?.[1]
      },
    },
    sort: {'file_id': 'DESC'}
  })
}
const boundHandle = (row: {id: number}) => {
  ElMessageBox.confirm('请确认是否绑定', '提示').then(() => {
    return bindApi({
      id: boundId,
      flowId: row.id
    })
  }).then(() => {
    ElMessage.success('绑定成功')
    // 刷新绑定表格
    showBoundFlow({id: boundId})
    searchBound()
  })

}

// 切换页面
const switchPages = (row: any) => {

  if (['费用报销', '用款申请'].includes(filterType(row.type) as any) || row.type === 'COST_RENT') {
    router.push({
      path: '/invoice-approve',
      query: { id: row.no }
    })
  }
  /* if (row.type !== 'COST_RENT') {
    return
  }
  router.push({
    path: '/lease-bill',
    query: {
      id: row.no
    }
  }) */
}


// ----------------
const tableRowClassName = ({ row, rowIndex }: any) => {
  // 支付失败
  if (row.status === 'PAY_FAILED') {
    return 'gray-row'
  }
  // 已驳回
  if (row.approvedStatus === 'TRUN_DOWN') {
    return 'gray-row'
  }
  // 支付成功
  if (row.status === 'PAY_SUCCESS') {
    return 'lightBule-row'
  }
  // 等待支付
  if (row.status === 'PAY_WAIT') {
    return 'green-row'
  }
  return ''
}

// 流转至工资发放
const salaryPackageVisiable=ref(false)
const salaryImportVisiable=ref(false)
const salaryImportForm=ref<any>({})
const salaryPackage=ref([])
const salaryPackageLoading=ref(false)
const salaryImportRef=ref()
const salaryTypeList= [
    { label: '福利', id: 'WELFARE' },
    { label: '奖金', id: 'BONUS' },
    { label: '工资', id: 'SALARY' },
    { label: '提成', id: 'COMMISSION' },
    { label: '考勤', id: 'ATTENDANCE' },
    { label: '个税', id: 'TAX' },
    { label: '养老保险', id: 'END_INS' },
    { label: '医疗保险', id: 'MED_INS' },
    { label: '失业保险', id: 'UNE_INS' },
    { label: '工伤保险', id: 'EMP_INS' },
    { label: '生育保险', id: 'MAT_INS' },
    { label: '住房公积金', id: 'HPF' },
    { label: '其他扣款', id: 'OD' },
    { label: '其他', id: 'OTHER' },
    { label: '一次性奖励', id: 'OTR' },
    { label: '个人部分', id: 'PERSON' },
]
const salaryCategoryList=ref([])
// 点击流转至工资发放
const transferPayrollhandle=()=>{
  if(!selectionData.value.length){   
    ElMessage.warning('请勾选要操作的数据')    
    return
  }
  salaryPackageVisiable.value=true
}
// 获取薪酬包
const getSalaryPackage=()=>{
  salaryPackageLoading.value=true
  transferPayrollQueryApi().then((res:any)=>{
    salaryPackage.value=res
  }).finally(()=>{
    salaryPackageLoading.value=false
  })
}
// 转薪酬
const transferPayroll=(id:any)=>{
  ElMessageBox.confirm("确认转薪酬至当前薪酬包？",{cancelButtonText:'取消',confirmButtonText:'确定'}).then(()=>{
    let params={
      idList:selectionData.value.map((el:any)=>el.id),salaryImportId:id
    }
    salaryPackageLoading.value=true
    transferPayrollApi(params).then((res:any)=>{
      ElMessage.success('操作成功')
      // getSalaryPackage()
      salaryPackageVisiable.value=false

    }).finally(()=>{
      salaryPackageLoading.value=false
    })
  })  
}
const newSalaryPackage=(formEl:any)=>{
  if (!formEl) return
  formEl.validate((valid:any) => {
    if (valid) {
        let {categoryId,content,date,remarks,type}=salaryImportForm.value
        let params={
          categoryId,content:content||'',date:dayjs(date).format("YYYY-MM-DD"),remarks:remarks||'',type,packtype:1
        }
        salaryImportsApi(params).then(()=>{
          salaryImportVisiable.value=false
          ElMessage.success("新增成功")          
          getSalaryPackage()
        })
    }
  })
}
const salaryPackageClose=()=>{
  payTableEle.value?.clearSelection()
  selectionData.value=[]
  getSalaryPackage()
  searchQuery()
}
const resetForm=(formEl:any)=>{
  if (!formEl) return
  formEl.resetFields()
  salaryImportForm.value={}
}

return (_ctx: any,_cache: any) => {
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_cascader = _resolveComponent("el-cascader")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_arrow_down = _resolveComponent("arrow-down")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_option_group = _resolveComponent("el-option-group")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_collapse, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_collapse_item, { title: "支付池-搜索" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form, {
              ref_key: "searchFormEle",
              ref: searchFormEle,
              inline: true,
              model: _unref(searchForm),
              "label-position": 'left',
              "label-width": "100px",
              class: "searchBg",
              disabled: tableLoading.value
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "序号:",
                  prop: "no"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input_number, {
                      modelValue: _unref(searchForm).no,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(searchForm).no) = $event)),
                      placeholder: "请输入序号",
                      clearable: "",
                      class: "form-input",
                      controls: false
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "ID:",
                  prop: "id"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      placeholder: "请输入ID",
                      modelValue: _unref(searchForm).id,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(searchForm).id) = $event)),
                      class: "form-input",
                      clearable: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "开票结算组织:",
                  prop: "payeeCompanies"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_cascader, {
                      modelValue: _unref(searchForm).payeeCompanies,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(searchForm).payeeCompanies) = $event)),
                      props: cascaderProps,
                      options: _unref(dropListArr).companyCascader,
                      clearable: "",
                      class: "form-input"
                    }, null, 8, ["modelValue", "options"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "费用申请部门:",
                  prop: "department"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _unref(searchForm).department,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(searchForm).department) = $event)),
                      placeholder: "选择一项",
                      clearable: "",
                      class: "form-input"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dropListArr).department, (item, idx) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: idx,
                            label: item,
                            value: item
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "费用类型:",
                  prop: "typeList"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _unref(searchForm).typeList,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(searchForm).typeList) = $event)),
                      placeholder: "选择一项",
                      clearable: "",
                      class: "form-input",
                      multiple: "",
                      "collapse-tags": ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dropListArr).type, (item, idx) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: idx,
                            label: _unref(filterType)(item),
                            value: item
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "费用类别:",
                  prop: "category"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      onChange: categoryChange,
                      modelValue: _unref(searchForm).category,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(searchForm).category) = $event)),
                      clearable: "",
                      placeholder: "选择一项",
                      class: "form-input"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(categoryList), (item, idx) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: idx,
                            label: item.category,
                            value: item.category
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "费用事项:",
                  prop: "matter"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      clearable: "",
                      modelValue: _unref(searchForm).matter,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(searchForm).matter) = $event)),
                      placeholder: "选择一项",
                      class: "form-input"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(metterList.value, (item, idx) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: idx,
                            label: item,
                            value: item
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "支付状态:",
                  prop: "status"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      clearable: "",
                      multiple: "",
                      "collapse-tags": "",
                      modelValue: _unref(searchForm).status,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(searchForm).status) = $event)),
                      placeholder: "选择一项",
                      class: "form-input"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dropListArr).status, (item, idx) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: idx,
                            value: item,
                            label: _unref(statusFilter)(item)
                          }, null, 8, ["value", "label"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "审核状态:",
                  prop: "payApproveStatusList"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      class: "form-input",
                      multiple: "",
                      "collapse-tags": "",
                      modelValue: _unref(searchForm).payApproveStatusList,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(searchForm).payApproveStatusList) = $event)),
                      placeholder: "选择一项",
                      clearable: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          value: "APPROVE_WAIT",
                          label: "Hr审核"
                        }),
                        _createVNode(_component_el_option, {
                          value: "APPROVE_SEC",
                          label: "财务审核"
                        }),
                        _createVNode(_component_el_option, {
                          value: "APPROVE_SUCCESS",
                          label: "审核成功"
                        }),
                        _createVNode(_component_el_option, {
                          value: "TRUN_DOWN",
                          label: "已驳回"
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "费用归属账号:",
                  prop: "accountNo"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      clearable: "",
                      modelValue: _unref(searchForm).accountNo,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(searchForm).accountNo) = $event)),
                      placeholder: "选择一项",
                      class: "form-input"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(accountNO), (item, idx) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: idx,
                            label: item.label,
                            value: item.value
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "出纳人:",
                  prop: "cashier"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      clearable: "",
                      modelValue: _unref(searchForm).cashier,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(searchForm).cashier) = $event)),
                      filterable: "",
                      placeholder: "选择一项",
                      class: "form-input"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).getters.sysUsers, (user) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            label: `${user.alias} (${user.realName})`,
                            value: user.alias,
                            key: user.userId
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "HR审批人:",
                  prop: "approvedBy"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      clearable: "",
                      modelValue: _unref(searchForm).approvedBy,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(searchForm).approvedBy) = $event)),
                      filterable: "",
                      placeholder: "选择一项",
                      class: "form-input"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).getters.sysUsers, (user) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            label: `${user.alias} (${user.realName})`,
                            value: user.userId,
                            key: user.userId
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "打包编号:",
                  prop: "approvedRecordId"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _unref(searchForm).approvedRecordId,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(searchForm).approvedRecordId) = $event)),
                      placeholder: "请输入打包编号",
                      clearable: "",
                      class: "form-input"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "发起人:",
                  prop: "creator"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _unref(searchForm).creator,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_unref(searchForm).creator) = $event)),
                      placeholder: "请输入发起人",
                      clearable: "",
                      class: "form-input"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "起止时间:",
                  prop: "createTime"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: _unref(searchForm).createTime,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(searchForm).createTime) = $event)),
                      clearable: "",
                      class: "form-input",
                      type: "daterange",
                      "value-format": "YYYY-MM-DD",
                      "range-separator": "-",
                      "start-placeholder": "开始时间",
                      "end-placeholder": "结束时间"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "最小金额:",
                  prop: "estimateAmountStart"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input_number, {
                      placeholder: "请输入最小金额",
                      modelValue: _unref(searchForm).estimateAmountStart,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_unref(searchForm).estimateAmountStart) = $event)),
                      class: "form-input",
                      clearable: "",
                      controls: false
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "最大金额:",
                  prop: "estimateAmountEnd"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input_number, {
                      placeholder: "请输入最大金额",
                      modelValue: _unref(searchForm).estimateAmountEnd,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_unref(searchForm).estimateAmountEnd) = $event)),
                      class: "form-input",
                      clearable: "",
                      controls: false
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _hoisted_1,
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: _cache[17] || (_cache[17] = ($event: any) => (searchQuery(true)))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_2
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_button, {
                      onClick: _cache[18] || (_cache[18] = ($event: any) => (searchFormEle.value?.resetFields()))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_3
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model", "disabled"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_el_button, {
        type: "primary",
        disabled: !selectionData.value.length,
        onClick: _cache[19] || (_cache[19] = ($event: any) => (swtichPaymentPage()))
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      }, 8, ["disabled"]),
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: _cache[20] || (_cache[20] = ($event: any) => (dialogFeeVisible.value = true)),
        disabled: tableLoading.value
      }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      }, 8, ["disabled"]),
      _createVNode(_component_el_button, {
        type: "primary",
        disabled: tableLoading.value,
        onClick: transferPayrollhandle
      }, {
        default: _withCtx(() => [
          _hoisted_7
        ]),
        _: 1
      }, 8, ["disabled"]),
      _createVNode(_component_el_button, {
        onClick: exportInvoiceData,
        disabled: tableLoading.value
      }, {
        default: _withCtx(() => [
          _hoisted_8
        ]),
        _: 1
      }, 8, ["disabled"]),
      _createVNode(_component_el_popover, {
        placement: "bottom",
        width: 400,
        trigger: "hover"
      }, {
        reference: _withCtx(() => [
          _createVNode(_component_el_button, { type: "info" }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_divider, null, {
            default: _withCtx(() => [
              _hoisted_10
            ]),
            _: 1
          }),
          _hoisted_11,
          _hoisted_12,
          _hoisted_13
        ]),
        _: 1
      })
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      ref_key: "payTableEle",
      ref: payTableEle,
      data: tableData.value,
      border: "",
      "row-class-name": tableRowClassName,
      onSelectionChange: handleSelectionChange,
      "row-key": getRowKey,
      "max-height": _unref(tableHeight) + 'px'
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          type: "selection",
          "reserve-selection": true,
          selectable: checkboxSelect,
          width: "50",
          fixed: ""
        }),
        _createVNode(_component_el_table_column, {
          label: "ID",
          prop: "id",
          fixed: ""
        }),
        _createVNode(_component_el_table_column, {
          label: "序号",
          prop: "no"
        }, {
          default: _withCtx(({ row }) => [
            (row.type === 'COST_RENT')
              ? (_openBlock(), _createBlock(_component_el_link, {
                  key: 0,
                  type: "primary",
                  onClick: ($event: any) => (switchPages(row))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(`ZL${row.no}`), 1)
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : (row.type === 'COST_SALARY')
                ? (_openBlock(), _createBlock(_component_el_link, { key: 1 }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(`GZ${row.no}`), 1)
                    ]),
                    _: 2
                  }, 1024))
                : (_openBlock(), _createBlock(_component_el_link, {
                    key: 2,
                    onClick: ($event: any) => (switchPages(row))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(row.no), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "打包编号",
          prop: "approvedRecordId",
          width: "110",
          formatter: (row) => row.approvedRecordId ? 'DB' + row.approvedRecordId : ''
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "数据来源",
          prop: "dataSource",
          width: "100",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "发起人",
          prop: "creator",
          width: "100",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "开票结算组织",
          prop: "payeeCompany",
          width: "150",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "费用申请部门",
          prop: "department",
          width: "140",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "费用归属账号",
          prop: "accountNo",
          width: "140"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(_unref(accountNoFilter)(row.accountNo)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "摘要",
          "show-overflow-tooltip": "",
          prop: "note",
          width: "180"
        }),
        _createVNode(_component_el_table_column, {
          label: "银行备注",
          "show-overflow-tooltip": "",
          prop: "bankNote",
          width: "180"
        }),
        _createVNode(_component_el_table_column, {
          label: "费用类型",
          width: "110",
          prop: "type"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(_unref(filterType)(row.type)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "费用类别",
          "show-overflow-tooltip": "",
          prop: "category",
          width: "180"
        }),
        _createVNode(_component_el_table_column, {
          label: "费用事项",
          "show-overflow-tooltip": "",
          prop: "matter",
          width: "180"
        }),
        _createVNode(_component_el_table_column, {
          label: "申请费用",
          prop: "estimateAmount",
          width: "110",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "支付金额",
          prop: "amount",
          width: "110",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "币种",
          prop: "payeeCurrency"
        }),
        _createVNode(_component_el_table_column, {
          label: "付款人",
          prop: "payByName",
          width: "110"
        }),
        _createVNode(_component_el_table_column, {
          label: "创建时间",
          prop: "createTime",
          width: "110"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(_unref(dayjs)(row.createTime).format("YYYY-MM-DD")), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "审批状态",
          prop: "approvedStatus",
          width: "100",
          formatter: ((row) => _unref(statusFilter)(row.approvedStatus))
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "支付状态",
          prop: "status",
          width: "100",
          "show-overflow-tooltip": ""
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(_unref(statusFilter)(row.status)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "驳回原因",
          prop: "rejectReason",
          width: "150",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "操作",
          fixed: "right"
        }, {
          default: _withCtx(({ row }) => [
            (row.status !== 'PAYMENT_REISSUED')
              ? (_openBlock(), _createBlock(_component_el_dropdown, {
                  key: 0,
                  trigger: "click"
                }, {
                  dropdown: _withCtx(() => [
                    _createVNode(_component_el_dropdown_menu, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_dropdown_item, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_link, {
                              disabled: row.status != 'PAY_NO',
                              onClick: ($event: any) => (editNote(row))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_16
                              ]),
                              _: 2
                            }, 1032, ["disabled", "onClick"])
                          ]),
                          _: 2
                        }, 1024),
                        (row.urgent == 0)
                          ? (_openBlock(), _createBlock(_component_el_dropdown_item, { key: 0 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_link, {
                                  disabled: row.urgent == 1,
                                  onClick: ($event: any) => (urgentHandle(1, row))
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_17
                                  ]),
                                  _: 2
                                }, 1032, ["disabled", "onClick"])
                              ]),
                              _: 2
                            }, 1024))
                          : _createCommentVNode("", true),
                        (row.urgent == 1)
                          ? (_openBlock(), _createBlock(_component_el_dropdown_item, { key: 1 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_link, {
                                  type: "danger",
                                  disabled: row.urgent == 0,
                                  onClick: ($event: any) => (urgentHandle(0, row))
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_18
                                  ]),
                                  _: 2
                                }, 1032, ["disabled", "onClick"])
                              ]),
                              _: 2
                            }, 1024))
                          : _createCommentVNode("", true),
                        (row.status == 'PAY_FAILED')
                          ? (_openBlock(), _createBlock(_component_el_dropdown_item, { key: 2 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_link, {
                                  onClick: ($event: any) => (oepnRepaymentsVisible(row))
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_19
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"])
                              ]),
                              _: 2
                            }, 1024))
                          : _createCommentVNode("", true),
                        _createVNode(_component_el_dropdown_item, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_link, {
                              type: "danger",
                              disabled: row.approvedStatus == "TRUN_DOWN",
                              onClick: ($event: any) => (showReject(row))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_20
                              ]),
                              _: 2
                            }, 1032, ["disabled", "onClick"])
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_el_dropdown_item, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_link, {
                              onClick: ($event: any) => (showUnboundFlow(row))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_21
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_14, [
                      _hoisted_15,
                      _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_arrow_down)
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data", "max-height"])), [
      [_directive_loading, tableLoading.value]
    ]),
    _createVNode(_component_el_pagination, {
      background: "",
      small: "",
      disabled: tableLoading.value,
      total: tableRowCount.value,
      currentPage: currentPage.value,
      "onUpdate:currentPage": _cache[21] || (_cache[21] = ($event: any) => ((currentPage).value = $event)),
      "page-size": pageSize.value,
      class: "mt-10",
      "page-sizes": [10, 30, 50, 100, 500],
      layout: "sizes, prev, pager, next, total, jumper",
      onCurrentChange: pageChange,
      onSizeChange: sizeChange
    }, null, 8, ["disabled", "total", "currentPage", "page-size"]),
    _createVNode(_component_el_dialog, {
      modelValue: dialogFeeVisible.value,
      "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((dialogFeeVisible).value = $event)),
      title: "内部转账",
      onClose: _cache[37] || (_cache[37] = ($event: any) => (closeTransferDialog(ruleFormRef.value))),
      draggable: "",
      width: "800px"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[34] || (_cache[34] = ($event: any) => (dialogFeeVisible.value = false))
        }, {
          default: _withCtx(() => [
            _hoisted_22
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          loading: transferLoading.value,
          disabled: transferLoading.value,
          onClick: _cache[35] || (_cache[35] = ($event: any) => (saveTransferData(ruleFormRef.value)))
        }, {
          default: _withCtx(() => [
            _hoisted_23
          ]),
          _: 1
        }, 8, ["loading", "disabled"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: transferData.value,
          rules: _unref(transferRules),
          ref_key: "ruleFormRef",
          ref: ruleFormRef,
          class: "transfer-form",
          inline: "",
          "label-width": "100px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "付款公司:",
              prop: "payerCompany"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  placeholder: "请选择付款公司",
                  modelValue: transferData.value.payerCompany,
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((transferData.value.payerCompany) = $event)),
                  onChange: payerCompanyChange,
                  class: "form-input"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(transferDropList.value, (el, idx) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: idx,
                        label: el.company,
                        value: el.company
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "付款银行:",
              prop: "payerBankName"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  placeholder: "请选择付款银行",
                  modelValue: transferData.value.payerBankName,
                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((transferData.value.payerBankName) = $event)),
                  onChange: payerBankNameChange,
                  class: "form-input"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(payerBankList.value, (el, idx) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: idx,
                        label: el.bankName,
                        value: el.bankName
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "付款账号:",
              prop: "payerAcc"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  placeholder: "请选择付款账号",
                  modelValue: transferData.value.payerAcc,
                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((transferData.value.payerAcc) = $event)),
                  class: "form-input"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(payerAcountNameList.value, (el, idx) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: idx,
                        label: el.accountName,
                        value: el.accountId
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "申请金额:",
              prop: "estimateAmount"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input_number, {
                  placeholder: "请输入申请金额",
                  controls: false,
                  modelValue: transferData.value.estimateAmount,
                  "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((transferData.value.estimateAmount) = $event)),
                  class: "form-input"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "支付金额:",
              prop: "amount"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input_number, {
                  placeholder: "请输入支付金额",
                  controls: false,
                  modelValue: transferData.value.amount,
                  "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((transferData.value.amount) = $event)),
                  class: "form-input"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "收款公司:",
              prop: "payeeCompany"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  placeholder: "请选择收款公司",
                  modelValue: transferData.value.payeeCompany,
                  "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((transferData.value.payeeCompany) = $event)),
                  onChange: payeeCompanyChange,
                  class: "form-input"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(transferDropList.value, (el, idx) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: idx,
                        label: el.company,
                        value: el.company
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "收款银行:",
              prop: "payeeBankName"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  placeholder: "请选择收款银行",
                  modelValue: transferData.value.payeeBankName,
                  "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((transferData.value.payeeBankName) = $event)),
                  onChange: payeeBankNameChange,
                  class: "form-input"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(payeeBankList.value, (el, idx) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: idx,
                        label: el.bankName,
                        value: el.bankName
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "收款账户名:",
              prop: "payeeAccountName"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  placeholder: "请选择收款账户名",
                  modelValue: transferData.value.payeeAccountName,
                  "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((transferData.value.payeeAccountName) = $event)),
                  onChange: payeeAccountNameChange,
                  class: "form-input"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(payeeAcountNameList.value, (el, idx) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: idx,
                        label: el.accountName,
                        value: el.accountName
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "收款账号:",
              prop: "payeeAcc"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  disabled: "",
                  value: transferData.value.payeeAcc,
                  class: "form-input",
                  placeholder: "请输入收款账号"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "币种:",
              prop: "payeeCurrency"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  placeholder: "请选择币种",
                  modelValue: transferData.value.payeeCurrency,
                  "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((transferData.value.payeeCurrency) = $event)),
                  class: "form-input",
                  disabled: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "人民币",
                      value: "CNY"
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "支付方式:",
              prop: "payType"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  placeholder: "请选择支付方式",
                  modelValue: transferData.value.payType,
                  "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((transferData.value.payType) = $event)),
                  class: "form-input",
                  disabled: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "手动付款",
                      value: "1"
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "业务类型:",
              prop: "businessCode"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  placeholder: "请选择业务类型",
                  modelValue: transferData.value.businessCode,
                  "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((transferData.value.businessCode) = $event)),
                  "value-key": 'optionKey',
                  class: "form-input"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(businessOption), (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        label: item.label,
                        value: item.value,
                        key: item.label
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "备注:" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "textarea",
                  clearable: "",
                  modelValue: transferData.value.note,
                  "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((transferData.value.note) = $event)),
                  style: {"width":"575px"},
                  rows: "3",
                  placeholder: "请输入内部转账备注"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: repaymentsVisible.value,
      "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((repaymentsVisible).value = $event)),
      title: "重新支付"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: repaymentsMethod
        }, {
          default: _withCtx(() => [
            _hoisted_24
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          inline: true,
          model: repaymentsModel.value
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "收款账户" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: repaymentsModel.value.payeeAccountName,
                  "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((repaymentsModel.value.payeeAccountName) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "收款银行" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: repaymentsModel.value.payeeBankName,
                  "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((repaymentsModel.value.payeeBankName) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "收款账号" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: repaymentsModel.value.payeeAcc,
                  "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((repaymentsModel.value.payeeAcc) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      width: "450px",
      modelValue: noteVisiable.value,
      "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((noteVisiable).value = $event)),
      title: "编辑银行备注",
      draggable: ""
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[43] || (_cache[43] = ($event: any) => (noteVisiable.value = false))
        }, {
          default: _withCtx(() => [
            _hoisted_25
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: setNote
        }, {
          default: _withCtx(() => [
            _hoisted_26
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_input, {
          modelValue: noteText.value,
          "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((noteText).value = $event)),
          placeholder: "请输入摘要",
          clearable: "",
          rows: "6",
          type: "textarea"
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "驳回原因",
      onClose: _cache[48] || (_cache[48] = ($event: any) => (rejectReason.value = '')),
      modelValue: rejectFg.value,
      "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((rejectFg).value = $event))
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[46] || (_cache[46] = ($event: any) => (rejectFg.value = false))
        }, {
          default: _withCtx(() => [
            _hoisted_27
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[47] || (_cache[47] = ($event: any) => (rejectApprove()))
        }, {
          default: _withCtx(() => [
            _hoisted_28
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_input, {
          placeholder: "请输入驳回原因",
          type: "textarea",
          modelValue: rejectReason.value,
          "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((rejectReason).value = $event)),
          rows: 5
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "薪酬包选择",
      width: "80%",
      onClose: salaryPackageClose,
      modelValue: salaryPackageVisiable.value,
      "onUpdate:modelValue": _cache[60] || (_cache[60] = ($event: any) => ((salaryPackageVisiable).value = $event))
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[59] || (_cache[59] = ($event: any) => (salaryPackageVisiable.value=false))
        }, {
          default: _withCtx(() => [
            _hoisted_32
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_button, {
          class: "mb-10",
          onClick: _cache[50] || (_cache[50] = ($event: any) => (salaryImportVisiable.value=true)),
          type: "primary"
        }, {
          default: _withCtx(() => [
            _hoisted_29
          ]),
          _: 1
        }),
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          height: "500",
          data: salaryPackage.value,
          border: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "ID",
              prop: "id",
              width: "80"
            }),
            _createVNode(_component_el_table_column, {
              label: "摘要",
              prop: "content"
            }),
            _createVNode(_component_el_table_column, {
              label: "导入日期",
              formatter: (row)=>_unref(dayjs)(row.createdAt).format('YYYY-MM-DD')
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              label: "所属日期",
              prop: "date"
            }),
            _createVNode(_component_el_table_column, {
              label: "导入项目",
              prop: "categoryName"
            }),
            _createVNode(_component_el_table_column, {
              label: "总金额",
              prop: "amount",
              formatter: _unref(formatNumber),
              align: "right"
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              label: "操作人",
              prop: "operator",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              label: "备注",
              prop: "remarks",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              label: "操作",
              prop: "ops",
              width: "100",
              align: "center"
            }, {
              default: _withCtx(({row}) => [
                _createVNode(_component_el_button, {
                  link: "",
                  type: "primary",
                  onClick: ($event: any) => (transferPayroll(row.id))
                }, {
                  default: _withCtx(() => [
                    _hoisted_30
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, salaryPackageLoading.value]
        ]),
        _createVNode(_component_el_dialog, {
          onClose: _cache[57] || (_cache[57] = ($event: any) => (resetForm(salaryImportRef.value))),
          width: "750",
          title: "薪酬数据导入",
          modelValue: salaryImportVisiable.value,
          "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event: any) => ((salaryImportVisiable).value = $event))
        }, {
          footer: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[56] || (_cache[56] = ($event: any) => (newSalaryPackage(salaryImportRef.value)))
            }, {
              default: _withCtx(() => [
                _hoisted_31
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_form, {
              inline: "",
              "label-width": "100",
              ref_key: "salaryImportRef",
              ref: salaryImportRef,
              model: salaryImportForm.value
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "导入摘要",
                  prop: "content"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      style: {"width":"214px"},
                      modelValue: salaryImportForm.value.content,
                      "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((salaryImportForm.value.content) = $event)),
                      placeholder: "请输入摘要"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "所属日期",
                  prop: "date",
                  rules: [{ required: true, message: '请选择所属日期', trigger: 'change' }]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: salaryImportForm.value.date,
                      "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((salaryImportForm.value.date) = $event)),
                      type: "date",
                      placeholder: "请选择所属日期",
                      style: {"width":"214px"}
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "类别",
                  prop: "type",
                  rules: [{ required: true, message: '请选择类别', trigger: 'change' }]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: salaryImportForm.value.type,
                      "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((salaryImportForm.value.type) = $event))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(salaryTypeList, (item) => {
                          return _createVNode(_component_el_option, {
                            key: item.id,
                            value: item.id,
                            label: item.label
                          }, null, 8, ["value", "label"])
                        }), 64))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "导入项目",
                  prop: "categoryId",
                  rules: [{ required: true, message: '请选择类别', trigger: 'change' }]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: salaryImportForm.value.categoryId,
                      "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => ((salaryImportForm.value.categoryId) = $event))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(salaryCategoryList.value, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.id,
                            value: item.id,
                            label: item.name
                          }, null, 8, ["value", "label"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "备注",
                  prop: "remarks"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      style: {"width":"214px"},
                      modelValue: salaryImportForm.value.remarks,
                      "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => ((salaryImportForm.value.remarks) = $event)),
                      placeholder: "请输入备注"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "流水绑定",
      modelValue: isShowBound.value,
      "onUpdate:modelValue": _cache[73] || (_cache[73] = ($event: any) => ((isShowBound).value = $event)),
      width: "1200px",
      onClose: _cache[74] || (_cache[74] = ($event: any) => (boundEle.value.resetFields()))
    }, {
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          data: boundDate.value,
          border: "",
          "max-height": "250",
          "show-summary": "",
          "summary-method": bindTotal
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "账户简称",
              prop: "accountName",
              "show-overflow-tooltip": "",
              fixed: ""
            }),
            _createVNode(_component_el_table_column, {
              label: "日期",
              prop: "collectionAt",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              label: "币种",
              prop: "currency",
              width: "100"
            }),
            _createVNode(_component_el_table_column, {
              label: "金额",
              prop: "costOut",
              align: "right"
            }, {
              default: _withCtx(({row}) => [
                _createTextVNode(_toDisplayString(_unref(getNumber)(row.costOut - row.costIn)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "收付方名称",
              prop: "costTo",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              label: "银行摘要",
              prop: "summary",
              "min-width": "200",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              label: "操作",
              fixed: "right"
            }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_el_link, {
                  onClick: ($event: any) => (delDetails(row.id)),
                  type: "danger"
                }, {
                  default: _withCtx(() => [
                    _hoisted_33
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, boundLoad.value]
        ]),
        _createVNode(_component_el_divider),
        _createVNode(_component_el_form, {
          ref_key: "boundEle",
          ref: boundEle,
          model: _unref(boundObj),
          inline: "",
          class: "searchBg",
          disabled: _unref(MI_identify)
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "银行名称:",
              prop: "bankName"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(boundObj).bankName,
                  "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event: any) => ((_unref(boundObj).bankName) = $event)),
                  class: "form-input",
                  placeholder: "请输入银行名称",
                  clearable: "",
                  maxlength: "200"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "银行摘要:",
              prop: "summary"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  placeholder: "请输入银行摘要",
                  class: "form-input",
                  clearable: "",
                  maxlength: "400",
                  modelValue: _unref(boundObj).summary,
                  "onUpdate:modelValue": _cache[62] || (_cache[62] = ($event: any) => ((_unref(boundObj).summary) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "公司名称:",
              prop: "costFrom"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _unref(boundObj).costFrom,
                  "onUpdate:modelValue": _cache[63] || (_cache[63] = ($event: any) => ((_unref(boundObj).costFrom) = $event)),
                  style: {"width":"310px"},
                  multiple: "",
                  "collapse-tags": "",
                  filterable: "",
                  placeholder: "请选择公司"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).getters.sysCompany, (group) => {
                      return (_openBlock(), _createBlock(_component_el_option_group, {
                        label: group.label,
                        key: group.label
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.options, (comp) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              label: comp.name,
                              value: comp.name,
                              key: comp.id
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 2
                      }, 1032, ["label"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "款项类型:",
              prop: "paymentType"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  class: "form-input",
                  filterable: "",
                  modelValue: _unref(boundObj).paymentType,
                  "onUpdate:modelValue": _cache[64] || (_cache[64] = ($event: any) => ((_unref(boundObj).paymentType) = $event)),
                  placeholder: "请选择款项类型",
                  clearable: "",
                  "allow-create": ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(paymentDropList), (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        label: item.label,
                        key: item.id,
                        value: item.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "交易日期",
              prop: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  modelValue: _unref(boundObj).collectionAt,
                  "onUpdate:modelValue": _cache[65] || (_cache[65] = ($event: any) => ((_unref(boundObj).collectionAt) = $event)),
                  type: "daterange",
                  "value-format": "YYYY-MM-DD",
                  "range-separator": "至",
                  "start-placeholder": "开始时间",
                  "end-placeholder": "结束时间"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createElementVNode("div", null, [
              _createVNode(_component_el_form_item, {
                label: "贷方金额:",
                prop: "costInStart",
                style: {"margin-right":"12px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input_number, {
                    controls: false,
                    placeholder: "请输入贷方金额起",
                    clearable: "",
                    modelValue: _unref(boundObj).costInStart,
                    "onUpdate:modelValue": _cache[66] || (_cache[66] = ($event: any) => ((_unref(boundObj).costInStart) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "至",
                prop: "costInEnd",
                "label-width": "auto"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input_number, {
                    controls: false,
                    placeholder: "请输入贷方金额止",
                    clearable: "",
                    modelValue: _unref(boundObj).costInEnd,
                    "onUpdate:modelValue": _cache[67] || (_cache[67] = ($event: any) => ((_unref(boundObj).costInEnd) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "借方金额:",
                prop: "costOutStart",
                style: {"margin-right":"12px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input_number, {
                    controls: false,
                    placeholder: "请输入借方金额起",
                    clearable: "",
                    modelValue: _unref(boundObj).costOutStart,
                    "onUpdate:modelValue": _cache[68] || (_cache[68] = ($event: any) => ((_unref(boundObj).costOutStart) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "至",
                prop: "costOutEnd",
                "label-width": "auto"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input_number, {
                    controls: false,
                    placeholder: "请输入借方金额止",
                    clearable: "",
                    modelValue: _unref(boundObj).costOutEnd,
                    "onUpdate:modelValue": _cache[69] || (_cache[69] = ($event: any) => ((_unref(boundObj).costOutEnd) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: _cache[70] || (_cache[70] = ($event: any) => (searchBound()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_34
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "disabled"]),
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          data: _unref(MI_tableData),
          "row-key": "id",
          border: "",
          "max-height": "400"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "账户ID",
              prop: "accountNumber",
              "show-overflow-tooltip": "",
              fixed: ""
            }),
            _createVNode(_component_el_table_column, {
              label: "公司简称",
              prop: "companyAlias",
              width: "95",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              label: "账户简称",
              prop: "accountName",
              width: "135",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              label: "日期",
              prop: "collectionAt",
              width: "165",
              sortable: ""
            }, {
              default: _withCtx(({row}) => [
                _createElementVNode("span", null, _toDisplayString(_unref(dayjs)(row.collectionAt).format('YYYY-MM-DD HH:mm:ss')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "币种",
              prop: "currency"
            }),
            _createVNode(_component_el_table_column, {
              label: "借方",
              prop: "costOut",
              width: "135",
              formatter: _unref(formatNumber),
              align: "right"
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              label: "借方本位币",
              prop: "costOutStandardMoney",
              width: "135",
              formatter: _unref(formatNumber),
              align: "right"
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              label: "贷方",
              prop: "costIn",
              width: "135",
              formatter: _unref(formatNumber),
              align: "right"
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              label: "贷方本位币",
              prop: "costInStandardMoney",
              width: "135",
              formatter: _unref(formatNumber),
              align: "right"
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              label: "收款币别",
              prop: "receiptCurrency",
              width: "100"
            }),
            _createVNode(_component_el_table_column, {
              label: "收款金额",
              prop: "receiptAmount",
              width: "100",
              formatter: _unref(formatNumber),
              align: "right"
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              label: "手续费",
              prop: "handlingFee",
              width: "100",
              formatter: _unref(formatNumber),
              align: "right"
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              label: "收付方名称",
              prop: "costTo",
              width: "200",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              label: "收付方账号",
              prop: "costToAccount",
              width: "200",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              label: "银行摘要",
              prop: "summary",
              width: "200",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              label: "款项类型",
              prop: "paymentType",
              width: "120",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              label: "备注",
              prop: "remarks",
              width: "130",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              label: "团队",
              prop: "team",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              label: "状态",
              prop: "status"
            }),
            _createVNode(_component_el_table_column, {
              label: "操作",
              fixed: "right"
            }, {
              default: _withCtx(({row}) => [
                _createVNode(_component_el_link, {
                  type: "primary",
                  onClick: ($event: any) => (boundHandle(row))
                }, {
                  default: _withCtx(() => [
                    _hoisted_35
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, _unref(MI_identify)]
        ]),
        _createVNode(_component_el_pagination, {
          small: "",
          total: _unref(MI_total),
          disabled: _unref(MI_identify),
          currentPage: _unref(page),
          "onUpdate:currentPage": _cache[71] || (_cache[71] = ($event: any) => (_isRef(page) ? (page).value = $event : null)),
          "page-size": _unref(size),
          "onUpdate:page-size": _cache[72] || (_cache[72] = ($event: any) => (_isRef(size) ? (size).value = $event : null)),
          class: "mt-10",
          style: {"float":"none"},
          "page-sizes": [ 30, 50, 100, 200],
          layout: "sizes, prev, pager, next, total, jumper",
          onCurrentChange: _unref(MI_pageChange),
          onSizeChange: _unref(MI_sizeChange)
        }, null, 8, ["total", "disabled", "currentPage", "page-size", "onCurrentChange", "onSizeChange"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})